import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/img/home/font_img.png'
import _imports_1 from '../../../assets/img/hr.png'


const _withScopeId = n => (_pushScopeId("data-v-76db12e4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-box" }
const _hoisted_2 = { class: "bx" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<img class=\"title-img\" src=\"" + _imports_0 + "\" alt=\"\" data-v-76db12e4><div class=\"title\" data-v-76db12e4><img src=\"" + _imports_1 + "\" data-v-76db12e4> 我们都在奔跑的路上 <img src=\"" + _imports_1 + "\" data-v-76db12e4></div><div class=\"sub-title\" data-v-76db12e4> 最近连续在体育频道看见跑鞋的广告，忽然间意识到，跑步这项运动火了。几年前曾经有这样的论调，当人均GDP达到8000美元的时候，马拉松运动将以井喷的势态呈现，关注一下经济状况与跑步活动的频度，显然我们还没有达到预期井喷的收入，但确实已经有了一窝蜂的跑步赛事，仅仅2012这一年里,国内各地区举办马拉松的城市就翻了一番，新增马拉松人口呈几何增长，这与人们逐步意识到跑步的社会价值密不可分。跑步，就是做公益。 </div>", 3)
const _hoisted_6 = { class: "tab-nav" }
const _hoisted_7 = {
  key: 0,
  src: "https://static.yzou.cn/website/video/057A40359D814DC9B8B6F0B937E4CEED.mp4",
  controls: "controls"
}
const _hoisted_8 = {
  key: 1,
  src: "https://static.yzou.cn/website/video/057A40359D814DC9B8B6F0B937E4CEED.mp4",
  controls: "controls"
}
const _hoisted_9 = {
  key: 2,
  src: "https://static.yzou.cn/website/video/057A40359D814DC9B8B6F0B937E4CEED.mp4",
  controls: "controls"
}

import { ref } from 'vue';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const tag = ref('1');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tag.value = '1')),
          class: _normalizeClass({ active: tag.value === '1' })
        }, "远智教育教育", 2),
        _createElementVNode("span", {
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tag.value = '2')),
          class: _normalizeClass({ active: tag.value === '2' })
        }, "视频2", 2),
        _createElementVNode("span", {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (tag.value = '3')),
          class: _normalizeClass({ active: tag.value === '3' })
        }, "视频3", 2)
      ]),
      (tag.value === '1')
        ? (_openBlock(), _createElementBlock("video", _hoisted_7))
        : (tag.value === '2')
          ? (_openBlock(), _createElementBlock("video", _hoisted_8))
          : (tag.value === '3')
            ? (_openBlock(), _createElementBlock("video", _hoisted_9))
            : _createCommentVNode("", true)
    ])
  ]))
}
}

})